import { PropsWithChildren } from 'react';
import { Field, FieldProps } from 'formik';
import { SwitchWrapper, SwitchWrapperProps } from './SwitchWrapper';

export interface FormikSwitchWrapperProps extends SwitchWrapperProps {
  fieldName: string;
}

export function FormikSwitchWrapper({
  fieldName,
  ...switchWrapperProps
}: PropsWithChildren<FormikSwitchWrapperProps>) {
  return (
    <Field name={fieldName}>
      {({ field, form }: FieldProps) => (
        <SwitchWrapper
          {...switchWrapperProps}
          switchProps={{
            name: fieldName,
            checked: !!field.value,
            ...switchWrapperProps.switchProps,
            onChange: async (event, checked) => {
              if (switchWrapperProps.switchProps?.onChange) {
                switchWrapperProps.switchProps?.onChange(event, checked);
              } else {
                await form.setFieldValue(field.name, checked);
              }
            }
          }}
        />
      )}
    </Field>
  );
}
